<template>
  <div class="myInfo">
    <!-- 其它信息 -->
    <div class="block">
      <div class="title">
        <span>此部分信息用于生成获奖证书</span>
        <button v-if="!changeUser" @click="changeUser = true">修改</button>
        <button v-else @click="saveUser()">保存</button>
      </div>
      <div class="card">
        <div class="row addImage">
          <span class="lable">证件照</span>
          <div @click="changeUser && clickInput()" :class="{notAllow:!changeUser}">
            <input type="file" ref="upload" accept="image/*" @change="ImageChange" style="display:none;" />
            <i class="el-icon-plus" v-if=" !owner.photo && !IdPhoto"></i>
            <img :src="IdPhoto || owner.photo" v-else />
          </div>
          <span class="tips">请上传标准2寸（宽*高：413*626）证件照照片</span>
        </div>
        <div class="row">
          <span class="lable">就读学校</span>
          <input placeholder="请填写就读学校" class="notAllow" :value="owner.school" readonly v-if="!changeUser" />
          <input placeholder="请填写就读学校" v-model="school" v-else />
        </div>
        <div class="row">
          <span class="lable">学生真实姓名</span>
          <input class="notAllow" :value="owner.realname" placeholder="请联系班主任修改" readonly />
        </div>
      </div>
    </div>
    <div class="block">
      <div class="title">
        <span>此部分信息用于邮寄获奖奖品或开学礼包等等</span>
        <button v-if="!changeAddress" @click="changeAddress = true">修改</button>
        <button v-else @click="saveAddress()">保存</button>
      </div>
      <div class="card">
        <div class="row">
          <span class="lable">收件人</span>
          <input placeholder="请填写收件人姓名" v-model="address.linkman" :class="{notAllow:!changeAddress}" :readonly="!changeAddress" />
        </div>
        <div class="row">
          <span class="lable">手机号</span>
          <input placeholder="请填写收件人手机号" v-model="address.telephone" :class="{notAllow:!changeAddress}" type="number" :readonly="!changeAddress" />
        </div>
        <template v-if="!newAddress">
          <div class="row">
            <span class="lable">地址</span>
            <input v-model="address.shipping_address" type="text" :class="{notAllow:!changeAddress}" :readonly="!changeAddress" />
          </div>
        </template>
        <template v-else>
          <div class="row">
            <span class="lable">所在地区</span>
            <el-cascader v-model="value" :props="{value:'label'}" separator="-" :options="city"></el-cascader>
          </div>
          <div class="row">
            <span class="lable">详细地址</span>
            <input placeholder="请填写详细地址" v-model="address.shipping_address" type="text" :class="{notAllow:!changeAddress}" :readonly="!changeAddress" />
          </div>
        </template>

      </div>
    </div>

    <!-- 图片裁剪 -->
    <ShadowView ref="shadowView">
      <CropperImg
        @cropperEvent="cropperEvent"
        :src="cropper_url"
        :proportion="cropper_proportion"
      />
    </ShadowView>
  </div>
</template>

<script>
import {
  UPLOAD_SINGLE_IMAGE
} from '@/utils'
import { POST, GET, PUT } from '@/utils/request'
import city from '@/assets/city.json'
import { mapActions } from 'vuex'

import CropperImg from "./components/CropperImg";
import ShadowView from "./components/ShadowView";

export default {
  name: 'MyInfo',
  components: {
    CropperImg,
    ShadowView
  },
  data () {
    return {
      IdPhoto: '',
      school: '',
      changeUser: false,

      value: [],
      city: city,
      changeAddress: false,
      newAddress: true,
      address: {},

      // 裁剪图片的比例(高/宽)
      cropper_proportion: 626 / 413,
      // 裁剪图片的地址
      cropper_url: "",
    }
  },
  props: ["owner"],
  created () {
    this.getAddressInfo()
    this.IdPhoto = this.owner.photo;
    this.school = this.owner.school
  },
  methods: {
    ...mapActions(["changeLoading"]),
    // 获取地址信息
    getAddressInfo () {
      this.changeAddress = false
      GET('/server/userinfo/addresses/')
        .then(res => {
          if (res.count > 0) {
            this.address = res.results[0]
            this.newAddress = false
          }
        })
    },
    // 保存地址
    saveAddress () {
      if (!this.address.linkman || !this.address.telephone || !this.address.shipping_address) {
        this.$message.error('请将信息填写完整')
        return
      }
      if (this.newAddress && this.value.length == 0) {
        this.$message.error('请将信息填写完整')
        return
      }
      let data = {
        linkman: this.address.linkman,
        telephone: this.address.telephone,
        shipping_address: this.address.shipping_address
      }
      if (this.newAddress) {
        data.shipping_address = this.value.join('') + this.address.shipping_address
      }
      this.changeLoading(true)
      PUT('/server/userinfo/address_update/', data)
        .then(res => {
          this.changeLoading(false)
          this.$message.success('地址修改成功')
        })
    },
    // 点击input的按钮
    clickInput () {
      this.$refs.upload.click()
    },
    // image的input开始改变
    ImageChange (event) {
      let this_ = this
      let _URL = window.URL || window.webkitURL;
      let file = event.target.files[0]
      const imgReg = new RegExp("image");
      if (file && !imgReg.test(file.type)) {//判断是不是图片文件
        this.$message.error('请选择图片文件')
        return
      }
      let image = new Image()
      image.src = _URL.createObjectURL(file);
      image.onload = function (event) {
        // 去裁剪图片，后上传
        this_.cropper_url = window.URL.createObjectURL(file);
        this_.$refs.shadowView.showShadowView();
        /*
        if ((image.width > 400 && image.width < 440) && (image.height > 600 && image.height < 640)) {
          this_.uploadPosterEvent(file)
        } else {
          this_.$message.error("请选择2寸证件照上传")
        }
        */
      }
    },
    uploadPosterEvent (blob) {
      this.changeLoading(true)
      let _this = this
      UPLOAD_SINGLE_IMAGE(blob, (url) => {
        _this.IdPhoto = url
        this.changeLoading(false)
      })
    },
    // 保存用户信息
    async saveUser () {
      // if (!this.IdPhoto || !this.school) {
      //   this.$message.error('请将信息填写完整')
      //   return
      // }
      this.changeLoading(true)
      let res = await PUT('server/userinfo/whoami/', {
        photo: this.IdPhoto,
        school: this.school
      })
      this.changeLoading(false)
      this.$message.success('信息修改成功')

    },

    // ------CropperImg 组件回传事件
    cropperEvent(data) {
      this.$refs.shadowView.hideShadowView();
      this.uploadPosterEvent(data);
    },
  },

}
</script>

<style lang="less" scoped>
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.myInfo {
  padding: 0 1.5rem 1rem 1.5rem;
}
.block {
  margin-top: 1.5rem;
  .title {
    font-size: 1rem;
    color: #6b45e1;
    line-height: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      font-size: 1rem;
      color: #ff7b00;
      cursor: pointer;
    }
  }
  .card {
    width: calc(100% - 3rem);
    background: #f8f8f8;
    padding: 2rem 1.5rem 1rem 1.5rem;
    margin-top: 0.5rem;
    border-radius: 1rem;
    .row {
      margin-bottom: 1.5rem;
      span.lable {
        width: 7rem;
        display: inline-block;
        text-align: right;
        font-size: 1rem;
        color: #666666;
      }
      span.tips {
        font-size: 1rem;
        color: #999;
      }
      input {
        width: calc(100% - 10rem);
        height: 3rem;
        border-radius: 0.4rem;
        border: none;
        padding: 0 1rem;
        margin-left: 1rem;
      }
      .notAllow {
        cursor: not-allowed;
      }
      /deep/.el-cascader {
        width: calc(100% - 8rem);
        margin-left: 1rem;
        input {
          width: 100%;
          height: 3rem;
          border-radius: 0.4rem;
          border: none;
          padding: 0 1rem;
        }
      }
    }
    .addImage {
      display: flex;
      align-items: center;
      div {
        min-height: 4rem;
        width: 4rem;
        background: #ffffff;
        color: #6b45e1;
        font-size: 3rem;
        margin-left: 1rem;
        line-height: 4rem;
        text-align: center;
        border-radius: 0.4rem;
        margin-right: 1rem;
        img {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
</style>